import { ReactComponent as CN } from '../../../assets/flags/CN.svg';
import { ReactComponent as CZ } from '../../../assets/flags/CZ.svg';
import { ReactComponent as DE } from '../../../assets/flags/DE.svg';
import { ReactComponent as DK } from '../../../assets/flags/DK.svg';
import { ReactComponent as ES } from '../../../assets/flags/ES.svg';
import { ReactComponent as FR } from '../../../assets/flags/FR.svg';
import { ReactComponent as GB } from '../../../assets/flags/GB.svg';
import { ReactComponent as IT } from '../../../assets/flags/IT.svg';
import { ReactComponent as JP } from '../../../assets/flags/JP.svg';
import { ReactComponent as KR } from '../../../assets/flags/KR.svg';
import { ReactComponent as PL } from '../../../assets/flags/PL.svg';
import { ReactComponent as RU } from '../../../assets/flags/RU.svg';
import { ReactComponent as SE } from '../../../assets/flags/SE.svg';
import { ReactComponent as SK } from '../../../assets/flags/SK.svg';
import { ReactComponent as UZ } from '../../../assets/flags/UZ.svg';

const FlagType = {
  CN,
  CZ,
  DE,
  DK,
  ES,
  FR,
  GB,
  IT,
  JP,
  KR,
  PL,
  RU,
  SE,
  SK,
  UZ,
};

export default FlagType;
